import { Deserializable } from '../protocols/deserializable';
import { MemberAccount } from './member-account';
import { TransactionEntryLegacyCodeType } from './transaction-entry-legacy-code-type';
import { FundType } from './fund-type';
import * as moment from 'moment';

export class TransactionEntry implements Deserializable {
  public id!: string;
  public transactionId!: number;
  public accountId!: number;
  public account!: MemberAccount;
  public fundId!: number;
  public fund!: FundType;
  public codeId!: number;
  public codeName!: string;
  public codeIdAndName!: string;
  public legacyCodeId!: number | null;
  public legacyCode!: TransactionEntryLegacyCodeType | null;
  public debitedUnitCount!: number | null;
  public creditedUnitCount!: number | null;
  public unitSettlementPrice!: number;
  public settledDebitValue!: number | null;
  public settledCreditValue!: number | null;
  public createdDate: string | null = null;
  public postedDate: string | null = null;

  // Not from API
  public formattedPostedDate: string | null = null;

  onDeserialize() {
    if (this.account) {
      this.account = window?.injector?.Deserialize.instanceOf(MemberAccount, this.account);
    }
    if (this.legacyCode) {
      this.legacyCode = window?.injector?.Deserialize.instanceOf(TransactionEntryLegacyCodeType, this.legacyCode);
    }
    if (this.fund) {
      this.fund = window?.injector?.Deserialize.instanceOf(FundType, this.fund);
    }
    if (this.postedDate) {
      this.formattedPostedDate = moment(this.postedDate).format('MMMM DD, yyyy');
    }
  }
}
